<template>
  <div class="panel mt-20">
    <el-table v-if="!isMobile()" :data="quotations" stripe key="quotations">
      <el-table-column prop="number" label="报价单编号" width="160">
        <template slot-scope="scope">
          <quotation-link :quotation="scope.row"></quotation-link>
        </template>
      </el-table-column>
      <el-table-column prop="order_info.project_name" label="项目">
      </el-table-column>
      <el-table-column prop="created_at" label="日期" width="140">
        <template slot-scope="scope">
          {{ formatTime(scope.row.created_at, 'YYYY/M/D HH:mm') }}
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="金额(￥)"
        width="120"
      ></el-table-column>
      <el-table-column label="状态" width="90">
        <template slot-scope="scope">
          <span
            class="status-point"
            :class="'bg-' + QuotationStatusMap[scope.row.status].type"
          ></span>
          <span :class="'text-' + QuotationStatusMap[scope.row.status].type">
            {{ QuotationStatusMap[scope.row.status].name }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" v-if="!customerDeleted">
        <template slot-scope="scope">
          <div class="flex-row-between">
            <!-- <el-button
              v-if="scope.row.status == 1"
              size="mini"
              type="danger"
              @click="deleteQuotation(scope.$index)"
              plain
              >删除</el-button
            >-->
            <router-link
              v-if="scope.row.status == 1 || scope.row.status == 3"
              :to="'/dashboard/new_quotation?quotation=' + scope.row.id"
              v-permission="Auth.quotationEdit"
            >
              <el-button
                v-if="scope.row.status == 1"
                size="mini"
                type="primary"
                plain
                >修改</el-button
              >
            </router-link>
          </div>
          <!-- <div
            v-if="
              scope.row.status == 1 ||
                scope.row.status == 3 ||
                scope.row.status == 4
            "
            class="mt-10"
          >
            <el-button
              v-if="scope.row.status == 1 || scope.row.status == 3"
              size="mini"
              plain
              type="primary"
              @click="submitApproval(scope.$index)"
              >提交审核</el-button
            >
            <el-button
              v-if="scope.row.status == 4"
              size="mini"
              plain
              type="primary"
              >申请订单</el-button
            >
          </div>-->
        </template>
      </el-table-column>
    </el-table>
    <ul v-else class="list-style">
      <li v-for="q in quotations">
        <div>
          <quotation-link :quotation="q" :origin="2"></quotation-link>
        </div>
        <div class="font-12 flex-row-between">
          <span>销售：{{ q.user.name }}</span>
          <span>金额：￥{{ q.order_info.amount }}</span>
        </div>
        <div class="font-12 flex-row-between">
          <span>{{ formatTime(q.created_at) }}</span>
          <span>
            <status-tag
              :type="QuotationStatusMap[q.status].type"
              :name="QuotationStatusMap[q.status].name"
            ></status-tag>
          </span>
        </div>
      </li>
    </ul>
    <div v-if="quotations.length == 0 && isMobile()" class="text-info-12">
      暂未创建报价单。
    </div>
  </div>
</template>

<script>
import { QuotationStatusMap } from '@/config/global'
import { formatTime, isMobile } from '@/util/index'
import {
  quotationList,
  updateQuotaionStatus,
  deleteQuotation,
} from '../../service/getData'
export default {
  props: {
    customerID: {
      type: Number,
    },
    customerDeleted: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return { formatTime, isMobile, QuotationStatusMap, quotations: [] }
  },
  created() {
    this.requestCustomerQuotations()
  },
  methods: {
    async requestCustomerQuotations() {
      let res = await quotationList({
        page: 0,
        size: 1000,
        customer_id: this.customerID,
      })
      this.quotations = res.data.list
    },
  },
}
</script>